export default __webpack_public_path__ + "static/media/wordpress-icon.50b2c04c.svg";